import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';
import { FaqsComponent } from '../../../../widgets/faqs/faqs.component';
import { FaqItem } from '../../../../core/interface/faq.modal';

@Component({
  selector: 'app-hybrid-cloud-monitoring',
  imports: [CommonModule, RouterModule, FeatureHero, FaqsComponent],
  templateUrl: './hybrid-cloud-monitoring.html',
  styleUrl: './hybrid-cloud-monitoring.scss',
})
export class HybridCloudMonitoring {
  faqs: FaqItem[] = [
    {
      question: 'What is a hybrid cloud?',
      answer: {
        paragraphs: ['A quintessential hybrid cloud is a combination of a private cloud with public cloud services with an interface to enable smooth interaction between the various hosting models. It grants enterprises the flexibility and scalability to manage increasing workflows without incurring heavy costs or deploying multiple monitoring tools. Hybrid clouds give them on-demand control to scale their operations and grow their business while creating a single source of data truth that comes with strict security and compliance protocols.']
      }
    },
    {
      question: 'What is hybrid cloud monitoring?',
      answer: {
        paragraphs: ['Hybrid cloud monitoring evaluates the health, availability, and performance of various applications, web servers, data storage devices, etc. The reason for its popularity is that while digital transformation is the need of the hour – many enterprises are unable to tackle the challenges inherent to managing different cloud models. Using hybrid cloud monitoring, they easily manage public/private clouds and on-premises IT systems']
      }
    },
    {
      question: 'Why would an enterprise need a hybrid cloud monitoring solution?',
      answer: {
        paragraphs: ["In a nutshell, hybrid cloud monitoring empowers enterprises a significant amount of power to compute, store data, perform data analysis, etc., by making sure that the infrastructure is up and running. It helps achieve operational excellence, ensure compliance management, and advocate great user experiences. As earlier mentioned, it also plays a big role in enabling huge cost savings while increasing service and infrastructure reliability across the hybrid ecosystem."]
      }
    },
    {
      question: 'What are the major ways that hybrid cloud monitoring software can help?',
      answer: {
        list: {
          type: 'ul',
          items: [
            "Enable complete data control: Establish more data governance to set specific protocols for use cases",
            "Align cloud investments with business needs: Scale up computational capability based on unprecedented peaks or scale down to optimize resource usage",
            "Reduce application risks: Test workloads before onboarding new applications",
            "Create a proactive troubleshooting mechanism: Easily troubleshoot issues by proactively identifying ecosystem bottlenecks"
          ]
        }
      }
    },
    {
      question: 'What are the absolutely must-have hybrid cloud monitoring features?',
      answer: {
        paragraphs: ["Critical hybrid cloud monitoring features include Hybrid Cloud IT Visibility, Auto Discovery & Dependency Mapping, Predictive Hybrid Cloud Analytics, Integrated Fault & Incident Management, Consolidated Reporting, Centralized Alerts & Notifications, etc."]
      }
    }
  ];
}
